export const HTML = 'HTML';
export const TEXT = 'TEXT';

export default (address, type) => {

    const parts = [];
    if (address) {
        if (address.address) {
            parts.push(address.address);
        }
        if (address.address2) {
            parts.push(address.address2);
        }
        if (address.city) {
            parts.push(address.city);
        }
        if (address.state) {
            parts.push(address.state);
        }
        if (address.postcode) {
            parts.push(address.postcode);
        }
        if (address.country) {
            parts.push(address.country);
        }
    }
    let output = parts.join(type === HTML ? '<br />' : ', ');
    if (address.first_name || address.surname || address.company) {
        if (type === HTML) {
            if (address.company) {
                output = `<h4>${address.company}</h4><p>${output}</p>`;
            } else if (address.first_name) {
                output = `<h4>${address.first_name} ${address.surname}</h4><p>${output}</p>`;
            } else {
                output = `<p>${output}</p>`;
            }
        } else {
            if (address.company) {
                output = `${address.company}, ${output}`;
            } else if (address.first_name) {
                output = `${address.first_name} ${address.surname}, ${output}`;
            }
        }
    }
    return output;
}
